import React, { useState } from "react";
import { Col, Form, Input, Row, Space } from "antd";
import PrimaryButton from "../../../components/generic/buttons/PrimaryButton";
import SecondaryButton from "../../../components/generic/buttons/SecondaryButton";
import { convertAdjustmentObjectToArray } from "./utils";
import { useGetOrgIdentifier } from "../../generic/hooks/useGetOrgIdentifier";
import { getApiUrl } from "../../../service/network/UrlMapper";
import IntentType from "../../../intentexecutor/utils/IntentType";
import { performPostRequest } from "../../../service/network/NetworkService";
import ErrorNotificationComponent from "../../../components/generic/error/ErrorNotificationComponent";
import { Subject } from "rxjs";
import { EventType } from "../../../service/network/utils/EventType";
import { strings } from "../../utils/strings";

export const reportLogDataUpdateResponse = new Subject();

const EditModal = ({ months, keyName, year, onCancel, teamId }) => {
  const organizationIdentifier = useGetOrgIdentifier();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    const adjustments = convertAdjustmentObjectToArray(values, keyName, months);
    const payload = {
      year,
      organizationIdentifier,
      adjustments,
      teamId
    };

    if (adjustments.length) {
      setLoading(true);
      try {
        const result = await performPostRequest(
          getApiUrl()[IntentType.EDIT_TABLE_DATA],
          JSON.stringify(payload)
        );
        await result.json();
        reportLogDataUpdateResponse.next({
          type: EventType.REPORT_DATA_UPADTED,
        });
      } catch (error) {
        ErrorNotificationComponent(error);
      } finally {
        setLoading(false);
        onCancel();
      }
    }
  };

  return (
    <Form className="edit-modal" onFinish={onFinish}>
      <span className="note">
        <b>NOTE:</b> {strings.REPORTING_LOG_NOTE}
      </span>
      <Row gutter={[12,8]}>
        {months?.map((item) => (
          <Col span={8}>
            <span>{item}</span>
            <Form.Item name={item}>
              <Input />
            </Form.Item>
          </Col>
        ))}
      </Row>

      <Space className="reporting-buttons">
        <PrimaryButton
          buttonText={"Save"}
          htmlType="submit"
          loading={loading}
        />
        <SecondaryButton buttonText={"Cancel"} handleOnClick={onCancel} />
      </Space>
    </Form>
  );
};

export default EditModal;
